<div
  svcTestId="action-plan-escalate__modal--content"
  class="flex h-full flex-col bg-white"
>
  <div class="flex items-center justify-between border-b border-border py-4 pl-[18.4px] pr-[22px]">
    <div class="flex items-center gap-[5.5px]">
      <span
        class="inline-flex items-center"
        aria-hidden="true"
      >
        <svg
          width="20"
          height="12"
          viewBox="0 0 20 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12 2.4C11.3373 2.4 10.8 1.86274 10.8 1.2C10.8 0.537258 11.3373 0 12 0H18C18.6627 0 19.2 0.537258 19.2 1.2V7.2C19.2 7.86274 18.6627 8.4 18 8.4C17.3373 8.4 16.8 7.86274 16.8 7.2V4.09706L11.6485 9.24853C11.1799 9.71716 10.4201 9.71716 9.95147 9.24853L7.2 6.49706L2.04853 11.6485C1.5799 12.1172 0.820101 12.1172 0.351472 11.6485C-0.117157 11.1799 -0.117157 10.4201 0.351472 9.95147L6.35147 3.95147C6.8201 3.48284 7.5799 3.48284 8.04853 3.95147L10.8 6.70294L15.1029 2.4H12Z"
            fill="#4D4D4D"
          />
        </svg>
      </span>

      <h2 class="m-0 font-sans text-xl font-semibold leading-7 text-[#4D4D4D]">{{ 'Escalar' | transloco }}</h2>
    </div>

    <button
      svcTestId="action-plan-escalate__btn--close-header"
      mat-icon-button
      type="button"
      class="close-button flex h-[12px] w-[12px] min-h-[12px] min-w-[12px] items-center justify-center p-0"
      id="action-plan-escalate-close-button"
      (click)="onClose()"
    >
      <mat-icon
        class="h-[12px] w-[12px] text-[12px] text-default"
        svgIcon="heroicons_outline:x-mark"
      ></mat-icon>
    </button>
  </div>

  <div class="flex-1 overflow-y-auto px-2 pt-2">
    <form
      svcTestId="action-plan-escalate__section--form"
      [formGroup]="form"
      class="escalate-form flex flex-col gap-2"
    >
      @if (isObeyaContext) {
        <svc-chip
          svcTestId="action-plan-escalate__input--site"
          class="w-full"
          inputId="action-plan-escalate-site"
          formControlName="siteId"
          type="single"
          [label]="'Site' | transloco"
          [options]="store.sites()"
          [placeholder]="'Selecione' | transloco"
          [loading]="store.isLoadingSiteData()"
        ></svc-chip>
      }

      <svc-chip
        svcTestId="action-plan-escalate__input--responsible"
        class="w-full"
        inputId="action-plan-escalate-responsible"
        formControlName="responsibleIds"
        type="single"
        [label]="'Responsável' | transloco"
        [options]="responsibleOptions()"
        [placeholder]="'Selecione' | transloco"
        [loading]="store.isLoadingUsers()"
      ></svc-chip>

      @if (isObeyaContext) {
        <ng-container [ngTemplateOutlet]="lockedSystemTpl"></ng-container>

        <svc-chip
          svcTestId="action-plan-escalate__input--room"
          class="w-full"
          inputId="action-plan-escalate-room"
          formControlName="roomId"
          type="single"
          [label]="'Sala' | transloco"
          [options]="store.rooms()"
          [placeholder]="'Selecione' | transloco"
          [loading]="store.isLoadingSiteData()"
        ></svc-chip>

        <svc-chip
          svcTestId="action-plan-escalate__input--board"
          class="w-full"
          inputId="action-plan-escalate-board"
          formControlName="boardId"
          type="single"
          [label]="'Quadro' | transloco"
          [options]="store.boards()"
          [placeholder]="'Selecione' | transloco"
          [loading]="store.isLoadingBoards()"
        ></svc-chip>
      } @else if (canChangeSystem) {
        <svc-chip
          svcTestId="action-plan-escalate__input--system"
          class="w-full"
          inputId="action-plan-escalate-system"
          formControlName="systemIds"
          type="single"
          [label]="'Sistema' | transloco"
          [options]="systemsOptions"
          [placeholder]="'Selecione' | transloco"
        ></svc-chip>
      } @else {
        <ng-container [ngTemplateOutlet]="lockedSystemTpl"></ng-container>
      }

      <svc-audio-to-text-wrapper
        class="w-full"
        customClass="items-end escalate-comment-wrapper"
        [control]="form.controls.comment"
        [shadow]="false"
        [showVoiceToTextButton]="showVoiceToTextButton"
      >
        <svc-text
          svcTestId="action-plan-escalate__input--comment"
          inputId="action-plan-escalate-comment"
          class="w-full"
          formControlName="comment"
          [maxLength]="200"
          [label]="'Comentário' | transloco"
          [placeholder]="'Opcional' | transloco"
        ></svc-text>
      </svc-audio-to-text-wrapper>
    </form>
  </div>

  <div class="mt-auto border-t border-border px-2 pb-4 pt-2">
    <div class="flex justify-end gap-2">
      <svc-button-neutral
        svcTestId="action-plan-escalate__btn--close"
        id="action-plan-escalate-close"
        [label]="'Fechar' | transloco"
        type="button"
        (click)="onClose()"
      ></svc-button-neutral>

      <svc-button
        svcTestId="action-plan-escalate__btn--change"
        id="action-plan-escalate-change"
        type="button"
        color="primary"
        mode="flat"
        [disabled]="isChangeDisabled()"
        (click)="onChange()"
      >
        {{ 'Alterar' | transloco }}
      </svc-button>
    </div>
  </div>
</div>

<ng-template #lockedSystemTpl>
  <div
    svcTestId="action-plan-escalate__section--system-locked"
    class="flex flex-col"
  >
    <span class="font-sans text-[11px] font-normal leading-[22px] text-default">{{ 'Sistema' | transloco }}</span>
    <div class="flex h-[42px] items-center rounded-lg border border-[#C5CED9] p-2">
      <span
        svcTestId="action-plan-escalate__label--system-name"
        class="inline-flex items-center rounded-xl bg-[#E6E9EE] px-2 py-[2px] leading-5 text-default"
      >{{ systemName() || '-' }}</span>
    </div>
  </div>
</ng-template>
